// extracted by mini-css-extract-plugin
export default {"mainContainer":"styles_mainContainer__VDIC9","bodyContainer":"styles_bodyContainer__-1smh"};